<template>
    <ModalFormCard class="modal-default"
        :action='"/zapo/landing-page/review/import"'
        :submittedCallback='submittedCallback'
    >
        <template #title>Review sources</template>

        <template #default="{ saving, errors }">
            <!-- <input type="hidden" :value="options?.lp?.id" name="lp_id" /> -->
            <div class='grid grid-cols-1 gap-y-4'>
                <template v-for='(source, index) in options.lp.review_sources' :key='source.id'>
                    <div class='text-15 relative' :class='{ "border-t border-grey-500 pt-4": index > 0 }'>
                        <div class='flex items-center'>
                            <!-- <component :is='"IconSource"+$help.capitalizeFirstLetter(source.source.replace("mybuilder", "mb"))' class='w-4.5 h-4.5' /> -->
                            <p class='font-semibold'>{{ source.source }} {{ source.name ? '- ' + source.name : '' }}</p>
                        </div>

                        <div class='flex justify-between pt-2 text-grey-900 text-14'>
                            <div class=''>
                                <p>{{ source.contact_number || 'No contact number' }}</p>
                                <p>{{ source.web_address || 'No web address' }}</p>
                            </div>

                            <div class='text-right'>
                                <div class='flex items-center gap-x-0.5 h-4'>
                                    <IconStar class='w-4 h-4 stroke-red-500 fill-red-500' v-for='i in getReviewStars(source)' :key='i' />
                                </div>
                                <p class='pt-1' v-if='options.lp.reviews.filter(r => r.review_source_id == source.id).length > 0'>{{ options.lp.reviews.filter(r => r.review_source_id == source.id).length }} reviews</p>
                                <p class='pt-1' v-else>No reviews</p>
                            </div>
                        </div>

                        <div class='flex items-center mt-2'>
                            <template v-if='!source.verified_at'>
                                <IconAlert class='w-4.5 h-4.5 stroke-red-700' />
                                <p class='text-14 pl-2'>Not verified yet</p>
                            </template>
                            <template v-else>
                                <IconTickCircle class='w-4.5 h-4.5 stroke-green-600' />
                                <p class='text-14 pl-2'>Verified by {{ source.verified_by.first_name }}</p>
                            </template>
                        </div>

                        <div class="right-0 absolute top-0" :class='{ "!top-4": index > 0 }'>
                            <DropdownV2 :ignoreParent="true" :menuSpace="8" buttonCSS="" forceSide="right">
                                <template #button>
                                    <div class="icon-hover h-5 w-5 flex items-center justify-center">
                                        <IconAdditionalSettings class="h-5 w-5" />
                                    </div>
                                </template>
                                <template #menu>
                                    <div class="table-multi-select-menu bg-black min-w-[260px]">
                                        <p class="text-grey-800 text-14 pb-1.5 px-4 pt-0.5">Source options</p>

                                        <a :href='source.source_url' target='_blank' data-close>View source</a>
                                        <button type='button' data-close @click='verifySource(source)'>Verifiy</button>
                                        <button type='button' data-close @click='removeSource(source)'>Remove</button>
                                    </div>
                                </template>
                            </DropdownV2>
                        </div>
                    </div>
                </template>
            </div>

            <!-- <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default">
                    Import reviews
                </ButtonSaving>
            </div> -->
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        created() {
            this.value = {
                reviews: this.editingModel?.review,
            }
        },

        methods: {
            submittedCallback() {
                this.$event.$emit('modal-form-completed')
                this.$event.$emit('modal-close')
                this.$event.$emit('refresh-lp-preview')
            },

            getReviewStars(source) {
                let reviews = this.options.lp.reviews.filter(r => r.review_source_id == source.id)

                if (reviews.length == 0) {
                    return 0
                }

                return Math.round(reviews.reduce((sum, r) => sum + r.stars, 0) / reviews.length)
            },

            verifySource(source) {
                this.$axios.post(`/zapo/landing-page/review-source/${source.id}/verify`)
                    .then(() => {
                        this.$event.$emit('refresh-lp-preview')
                    });
            },

            removeSource(source) {
                this.$axios.delete(`/zapo/landing-page/review-source/${source.id}`)
                    .then(() => {
                        this.$event.$emit('refresh-lp-preview')
                    });
            }
        }
    }
</script>